export default "__VITE_ASSET__DIAcHIiJ__"